import React from 'react';
import { Alert, Button, Box } from '@mui/material';
import { useAuth } from '../hooks/useAuth';

const ImpersonationBanner = () => {
  const { impersonation, stopImpersonation, stoppingImpersonation } = useAuth();

  if (!impersonation?.originalUser) return null;

  const { originalUser } = impersonation;
  const originalName = [originalUser.first_name, originalUser.last_name].filter(Boolean).join(' ');

  return (
    <Box sx={{ position: 'sticky', top: 0, zIndex: (theme) => theme.zIndex.drawer + 2 }}>
      <Alert
        severity="warning"
        sx={{ borderRadius: 0 }}
        action={
          <Button
            color="inherit"
            size="small"
            disabled={stoppingImpersonation}
            onClick={stopImpersonation}
          >
            {stoppingImpersonation ? 'Returning…' : 'Stop impersonating'}
          </Button>
        }
      >
        You are viewing the app as this employee. Sign in as <strong>{originalName}</strong> when done testing.
      </Alert>
    </Box>
  );
};

export default ImpersonationBanner;
